import get from 'lodash.get';

import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

export const selectDeleteAccount = createDeepEqualSelector(selectAuth, (auth) => auth.deleteAccount);

export const selectLoading = createDeepEqualSelector(selectDeleteAccount, (requestPasswordReset) =>
  get(requestPasswordReset, 'loading', false),
);

export const selectSuccess = createDeepEqualSelector(selectDeleteAccount, (requestPasswordReset) =>
  get(requestPasswordReset, 'success', false),
);

export const selectError = createDeepEqualSelector(selectDeleteAccount, (requestPasswordReset) =>
  get(requestPasswordReset, 'err', false),
);

export const selectErrorMessage = createDeepEqualSelector(selectDeleteAccount, (requestPasswordReset) =>
  get(requestPasswordReset, 'errMsg', 'Error'),
);
